// src/data/reviewsData.js
export const reviews = [
    {
      id: "1",
      name: "Shrey Gupta",
      location: "Applied for Finland Visa - Oct'24",
      testimonial:
        "I can't express how happy I was to finally get my Schengen visa after facing two refusals in the past. Priyesh accurately identified the issues and guided me on the exact steps needed to secure the visa. With his clear instructions, the entire process turned out to be a breeze!",
      rating: 5,
    },
    {
      id: "2",
      name: "SHAILENDRA SAHU",
      location: "Applied for Austria Visa - Sept'24",
      testimonial:
        "The overall experience was amazing. Visa was approved within 3 days of application. Couldn't have asked for more.",
      rating: 5,
    },

    {
      id: "3",
      name: "Karan Dhanak",
      location: "Applied for France Visa - Nov'24",
      testimonial:
        "Priyesh and team were always very supportive and helped us at each stage. Will definitely seek help from them for future travels as well.",
      rating: 5,
    },

    {
      id: "4",
      name: "Annoymous",
      location: "Applied for Netherlands Visa - Nov'24",
      testimonial:
        "Priyesh has got me out of a 2 month long turmoil. I owe him, his guidance & confidence in getting me out of a visa refusal misery. Any one in doubt about a refusal - reach him out, not your agent!",
      rating: 5,
    },

    {
      id: "5",
      name: "Dr. Rajkumar R A",
      location: "Applied for Italy Visa - Nov'24",
      testimonial:
        "I got my Schengen visa for italy through priyesh. He was very prompt in clearing queries and his support in preparing documents for visa appointment was excellent. I would definitely utilise his services for future tours .",
      rating: 5,
    },

    {
      id: "6",
      name: "Mohammad",
      location: "Applied for UK Visa - Dec'24",
      testimonial:
        "Brilliant experience. Priyesh bhai replied with all my questions. Extremely underrated service and criminally under priced. Team has replied with patience and now I received my UK Visa. Thanks a lot",
      rating: 5,
    },

    {
      id: "7",
      name: "HARTEG SINGH",
      location: "Applied for Schengen Visa - Dec'24",
      testimonial:
        "A seamless experience with Mr. Priyesh. A knowledgeable person who always guides us to the right direction. Wish to see you grow more and still stay grounded as a person.",
      rating: 5,
    },

    {
      id: "8",
      name: "RAKSHIT SHARMA",
      location: "Applied for UK Visa - Dec'24",
      testimonial:
        "I'm thrilled with the Viszapp staff. I'm really grateful for Priyesh! He was incredibly helpful. Very pleased with the services. They managed me get my visa approved. Highly recommended.",
      rating: 5,
    },

    {
      id: "9",
      name: "Prateek Prasad",
      location: "Applied for Ireland Visa - Sept'24",
      testimonial: "Priyesh is a genius. Worth every penny",
      rating: 5,
    },

    {
      id: "10",
      name: "Shriniwas Jayant Gorane",
      location: "Applied for France Visa - Jan'25",
      testimonial:
        "The overall experience was a new learning for me. Kudos to Priyesh, Ridam and Team Viszapp for their dedicated services for our France Trip. This is my First International Trip and first is always special and memorable. Team Viszapp listened to all my queries, answered them and draft the perfect itinerary and assisted me in all the documentation part with the strongest cover letter. This resulted in swift approval from the France Embassy without any issues. I am recommending Viszapp to all my Clientele and Friends. Keep it up Guys.",
      rating: 5,
    },

    {
      id: "11",
      name: "Karan Raghuvanshi",
      location: "Applied for UK Visa - Jan'25",
      testimonial:
        "Priyesh from Viszapp provided excellent visa assistance for my UK tourist visa. My profile was a bit complicated, but he put in great effort to simplify it and present it effectively to the UK Embassy. His expertise and dedication made the process smooth, and I truly appreciate his support. Highly recommended for hassle-free visa assistance!",
      rating: 5,
    },

    {
      id: "12",
      name: "Prateek Prasad",
      location: "Applied for Greece - Dec'24",
      testimonial: "Talk about undercharging and over delivering 👌🏼",
      rating: 5,
    },

    {
      id: "13",
      name: "Himanshu Navalgaria",
      location: "Applied for Spain - Feb'25",
      testimonial:
        "My experience with Priyesh was nothing short of fantastic. It was a smooth journey throughout. He made it very easy for us to get the visa. thank you so much Viszapp team for your commendable efforts. Will 10/10 recommend.",
      rating: 5,
    },

    {
      id: "14",
      name: "Ameya Vichare",
      location: "Applied for UK & Switzerland Visa - Dec'24",
      testimonial:
        "Got both the UK visa and Schengen visa in a month for both me and my wife at a nominal fee. Thanks for all the help to Priyesh!",
      rating: 5,
    },

    {
      id: "15",
      name: "Chandra Sekhar Kartha",
      location: "Applied for Switzerland Visa - Feb'25",
      testimonial:
        "Very good experience with Priyesh and his team. Priyesh was very helpful with providing his inputs on docs required for the visa, cover letter etc. Made the process for the Schengen visa for myself and my parents smooth. Would recommend and go with him again in the future.",
      rating: 5,
    },

    {
      id: "16",
      name: "Abhishek Bhatia",
      location: "Applied for France Visa - Dec'24",
      testimonial: `Can't recommend Viszapp enough. I approached Priyesh via X in last week of November and asked if it's possible to plan a Christmas/New Year Europe trip for a family of 4. Within 2 weeks I had a multi entry visa from the France embassy for all of us.

        Priyesh was super helpful at every step, from guiding on application, creating a cover letter, itinerary. He helped us at each and every step and kept answering my stupid questions throughout.
        Strongly recommend anyone who's planning on applying any visa to go via Viszapp.`,
      rating: 5,
    },

    {
      id: "17",
      name: "Selvarathinam Senthil",
      location: "Applied for Japan Visa - Feb'25",
      testimonial: `I approached them for Japan visa.
        Even tough they didn't have slot they accommodated my request considering my urgency and helped in preparing documents for the visa.
        That was a great help for me considering the short time i gave them.
        I can recommend them blindly to any of my friends considering the professionalism on thier services.
        Thank you priyesh`,
      rating: 5,
    },

    {
      id: "18",
      name: "Lalit Khemnani",
      location: "Applied for Switzerland Visa - Feb'25",
      testimonial: `I recently used Viszapp services for visa assistance, and I couldn't be happier. Priyesh was incredibly helpful throughout the entire visa process, Patiently answering all my questions, guiding me through the requirements and ensuring all my documents were in order, Ridam helped me plan the itinerary based on my interest and preferences and thanks to their expertise we all got the Visa. Overall a fantastic experience .`,
      rating: 5,
    },
    {
      id: "19",
      name: "Abhishek Bhatia",
      location: "Applied for France Visa - Dec'24",
      testimonial: `Can't recommend Viszapp enough. I approached Priyesh via X in last week of November and asked if it's possible to plan a Christmas/New Year Europe trip for a family of 4. Within 2 weeks I had a multi entry visa from the France embassy for all of us. Priyesh was super helpful at every step, from guiding on application, creating a cover letter, itinerary. He helped us at each and every step and kept answering my stupid questions throughout. Strongly recommend anyone who's planning on applying any visa to go via Viszapp.`,
      rating: 5,
    },
    {
      id: "20",
      name: "shonak solanki",
      location: "Applied for USA Visa - Apr'25",
      testimonial: `e had a great experience with Vizapp! They guided us through the entire visa process with patience and expertise. They were extremely supportive and clarified all our doubts, and ensured that every step was completed smoothly. Highly recommend them to anyone looking for reliable visa consultants!`,
      rating: 5,
    },
    {
      id: "21",
      name: "Akanksha Singh",
      location: "Applied for Denmark Visa - March'25",
      testimonial: `Priyesh was very helpful with everything and answered all of my questions. I will definitely recommend everyone to get help from viszapp instead of overpriced agents who dont personalise anything. I had talked to 10-15 agents and none of them sounded promising to me and very dismissive about my concerns and most of them even said that my visa will be rejected. Priyesh reassured me when I wanted to give up and not apply for visa. I will never forget his help and his generosity.`,
      rating: 5,
    },

    {
      id: "22",
      name: "Annoymous",
      location: "Applied for Denmark Visa - April'25",
      testimonial: `I and my wife were struggling to get Schengen VISA, after our first rejection by Swiss embassy. After their valuable guidance (Ridam Jain and Priyesh Sharma) we got our first Schengen VISA to Denmark, which is one of the toughest to get. The cover letter was amazing and alignment of the documents was helpful. I would recommend them to everyone who is applying for VISA. I can now look forward to my travel plans with excitement and confidence. I am truly grateful for everything you've done in such a short notice.`,
      rating: 5,
    },

    {
      id: "23",
      name: "Ankit Pandey",
      location: "Applied for UK Visa - April'25",
      testimonial: `I have been following Priyesh since long time on social media. I saw his new venture being helpful to the travellers and novice like me. I will aim for Schengen next time. Thanks Ridam!`,
      rating: 4,
    },

    {
      id: "24",
      name: "Prateek Anand",
      location: "Applied for Switzerland Visa - April'25",
      testimonial: `After hearing much negativity about the visa process, Priyesh helped us understand every aspect. Our visa appointment was very swift; we were finished in about 25 minutes, and the visa arrived in just two days.`,
      rating: 5,
    },
  ];
  